export enum BoardingFlowMode {
    INITIAL = "INITIAL", SIGNUP = "SIGNUP", LOGIN = "LOGIN"
}
